import { Component, computed, inject, output, signal } from '@angular/core';
import { EduIconComponent, Icons } from '@atoms/icon/icon.component';
import { FileStore } from '@store/files/file.store';
import { TransferState } from '@store/files/types';
import { SharedCommonModule } from '@shared/common.module';

@Component({
  selector: 'edu-file-transfer-manager',
  templateUrl: './file-transfer-manager.component.html',
  imports: [SharedCommonModule, EduIconComponent],
})
export class EduFileTransferManagerComponent {
  private fileStore = inject(FileStore);

  public TransferState = TransferState;
  public Icons = Icons;

  public isMinimized = signal(false);

  // used for toggling animations
  public isVisible = signal(true);
  public isDismissedByUser = signal(false);

  // fired when the components close animation is complete
  public closed = output<{ isDismissedByUser: boolean }>();

  // order transfers by id, show active transfers first, then up to 3 settled ones
  public activeTransfers = computed(() => {
    const transfers = [...this.fileStore.transfersEntities()].sort((a, b) => b.id - a.id);
    let settledCount = 0;

    return transfers.filter(t => {
      if (t.state !== TransferState.DONE && t.state !== TransferState.FAILED) return true;
      return settledCount++ < 5;
    });
  });

  public close(isDismissedByUser = false) {
    this.isDismissedByUser.set(isDismissedByUser);
    this.isVisible.set(false);
  }

  public onLeave(event: AnimationEvent) {
    if (event.animationName === 'slide-down') {
      this.closed.emit({ isDismissedByUser: this.isDismissedByUser() });
    }
  }
}
